import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Dropdown from "@shared/v2/Dropdown";

const LastViewedMarketReportSelect = ({
  isDisabled,
  lastViewedMarketReportRangeOptions,
  previousSelectedRange,
}) => {
  const [selectedOption, setSelectedOption] = useState(
    lastViewedMarketReportRangeOptions.find((o) => o.value === previousSelectedRange) || null,
  );

  useEffect(() => {
    if (isDisabled === true) setSelectedOption(null);
  }, [isDisabled]);

  // Clear All wipes the DOM inputs via jQuery, which can't reach this
  // react-select's state — so reset it here too, otherwise the selection sticks
  // after Clear All.
  useEffect(() => {
    const clearButton = document.querySelector("#clear-all-modal-filters");
    const clear = () => setSelectedOption(null);
    clearButton?.addEventListener("click", clear);
    return () => clearButton?.removeEventListener("click", clear);
  }, []);

  return (
    <Dropdown
      label="Last Market Report View"
      id="last_viewed_market_report_filter"
      name="leads_filter[selected_last_viewed_market_report_filter][]"
      options={lastViewedMarketReportRangeOptions}
      placeholder="Select..."
      isClearable={false}
      onChange={setSelectedOption}
      isDisabled={isDisabled}
      value={selectedOption}
      menuShouldComeToFront
    />
  );
};

LastViewedMarketReportSelect.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  lastViewedMarketReportRangeOptions: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  previousSelectedRange: PropTypes.string.isRequired,
};

export default LastViewedMarketReportSelect;
